import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

/** Handle di una snackbar "fissata": resta valida anche se la snackbar viene sostituita e poi ripristinata */
export interface PinnedSnackbar {
  dismiss(): void;
}

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private _pinned: { component: ComponentType<unknown>; config: MatSnackBarConfig; ref: MatSnackBarRef<unknown> } | null = null;
  // messaggi temporanei aperti mentre c'è una snackbar fissata: quando finiscono tutti, quella fissata torna
  private _transientCount = 0;

  constructor(private _snackbar: MatSnackBar) {}

  // --------------------------------------------------------------------------------------------------------------------

  open(message: string, config: MatSnackBarConfig = { duration: 3000, verticalPosition: 'top' }): MatSnackBarRef<unknown> {
    const ref = this._snackbar.open(message, null, config);
    if (this._pinned) {
      // MatSnackBar ne mostra una sola: questo messaggio ha sostituito quella fissata
      this._transientCount++;
      ref.afterDismissed().subscribe(() => {
        this._transientCount--;
        this._restorePinned();
      });
    }
    return ref;
  }

  /**
   * Apre una snackbar senza durata (es. i comandi di un tool) che non va persa se un altro messaggio la sostituisce:
   * viene riaperta quando il messaggio sostitutivo si chiude. Si chiude solo con dismiss() dell'handle restituito.
   */
  openPinned<T>(component: ComponentType<T>, config: MatSnackBarConfig = {}): PinnedSnackbar {
    this._pinned?.ref.dismiss();
    this._pinned = null;
    this._transientCount = 0;
    this._pinned = { component, config, ref: this._snackbar.openFromComponent(component, config) };
    return {
      dismiss: () => {
        const pinned = this._pinned;
        this._pinned = null;
        pinned?.ref.dismiss();
      }
    };
  }

  // --------------------------------------------------------------------------------------------------------------------

  private _restorePinned(): void {
    if (!this._pinned || this._transientCount > 0) {
      return;
    }
    this._pinned.ref = this._snackbar.openFromComponent(this._pinned.component, this._pinned.config);
  }
}
